import React from "react";
import EmbedPage from "@/pages/EmbedPage";

export default function ChinaSuppliersPage() {
  return (
    <EmbedPage
      srcPath="/embeds/china-suppliers.html"
      titleKey="chinaSuppliers"
      testIdBase="china-suppliers"
      backHref="/country/cn"
    />
  );
}
